import { Alert, Snackbar } from "@mui/material";
import { createContext, useRef, useState } from "react";

const context = {
  openToast: () => {},
};

export const ToastContext = createContext(context);

// This is the default fade-out animation for the MUI Snackbar component
const ANIMATION_TIMEOUT = 255;

export const ToastContextProvider = ({ children }) => {
  // animationTimerRef is used to keep the state variables until the fade-out
  //   animation is complete
  const animationTimerRef = useRef();
  // timeoutTimerRef is used to automatically clear the alert from the page
  //   after a specified time (defaults to 10 seconds)
  const timeoutTimerRef = useRef();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(undefined);
  const [type, setType] = useState("error");

  const openToast = ({
    message: newMessage,
    type: newType = "error",
    timeout = 5000,
  }) => {
    if (animationTimerRef.current) {
      clearTimeout(animationTimerRef.current);
      animationTimerRef.current = null;
    }
    setOpen(true);
    setMessage(newMessage);
    setType(newType);
    if (timeout) {
      timeoutTimerRef.current = setTimeout(() => {
        setOpen(false);
        animationTimerRef.current = setTimeout(() => {
          setMessage(undefined);
          setType("error");
        }, ANIMATION_TIMEOUT);
      }, timeout);
    }
  };

  const handleClose = (_, reason) => {
    // Don't close on click away
    if (reason !== "clickaway") {
      setOpen(false);
      animationTimerRef.current = setTimeout(() => {
        setMessage(undefined);
        setType("error");
      }, ANIMATION_TIMEOUT);
      if (timeoutTimerRef.current) {
        timeoutTimerRef.current = null;
      }
    }
  };

  return (
    <ToastContext.Provider value={{ openToast }}>
      <Snackbar
        anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        open={open}
        onClose={handleClose}
      >
        <Alert
          variant="filled"
          severity={type}
          onClose={handleClose}
          sx={{ alignItems: "center" }}
        >
          {message}
        </Alert>
      </Snackbar>
      {children}
    </ToastContext.Provider>
  );
};
